import { render, staticRenderFns } from "./website-notice.vue?vue&type=template&id=38c2cc00&scoped=true"
import script from "./website-notice.vue?vue&type=script&lang=js"
export * from "./website-notice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c2cc00",
  null
  
)

export default component.exports